import { LocaleMessageObject } from "vue-i18n";

export default {
  name: "Eljot Dashboard",
  common: {
    email: "Email",
    code: "Code",
    password: "Password",
    login: "Login",
    signUp: "Create Account",
    activateAccount: "Activate account",
    forgotPassword: "Reset password",
    confirmPassword: "Confirm new password"
  },
  api: {
    notFound:
      "Our servers are unavailable at the moment. Please try again later.",
    forbidden: "You have no permission to do this. Are you logged in?",
    serverError:
      "Our servers have experienced an error. Please try again later.",
    wrongFormat: "The request data is invalid. Please try again later.",
    unknown: "An unknown error occurred. Please try again later."
  },
  auth: {
    errors: {
      invalidInput:
        "Please make sure you use a valid email address and a password with at least eight characters, two of which may not be letters.",
      userExists:
        "This email address is already in use. Do you maybe need to activate your account first or did you forget your password?",
      weakPassword:
        "The password is too weak. Use a password with at least eight characters, two of which may not be letters.",
      userUnknown:
        "We could not find an account for this email address. Please sign up first!",
      authFailed:
        "The combination of email address and password are wrong. Click <a href='/forgot-password'>here</a> if you forgot your password.",
      userNotConfirmed:
        "This account has not been activated yet. Please enter your verification code on the activation page.",
      unknown: "An unknown error occurred."
    },
    activate: {
      title: "Activate Account",
      description:
        "We have sent a code to your email address. Please enter it here to activate your account.",
      success: "Your account has been activated. You can now log in.",
      sendCodeAgain: "Send Code Again",
      codeSent: "We have sent a new code to your email address."
    },
    login: {
      title: "Login",
      description: "Please log in to gain access to this application.",
      rememberMe: "Stay logged in"
    },
    signUp: {
      title: "Create Account",
      description:
        "Please create an account to access this website. We will send you a code to verify your email address."
    },
    resetPassword: {
      title: "Reset Password",
      description:
        "If you forgot your password, please enter your email address and we will send you a verification code.",
      sendCode: "Send Code",
      success: "We have sent you a verification code to reset your password."
    },
    confirmPassword: {
      title: "Confirm new Password",
      description:
        "Please enter the verification code we sent to your email address to complete your password reset.",
      reset: "Set new password",
      success:
        "You have successfully set a new password. Please use it to log in."
    }
  },
  upload: {
    file_size_issue: "The file is too large. It must not exceed 5GB."
  }
} as LocaleMessageObject;
